<template>
  <div class="page-wrap" :style="isPC
      ? 'padding: 1.375rem 2.5vw 1.5rem; overflow-x: hidden'
      : 'padding: 3.375rem 2.5vw 1.5rem; overflow-x: hidden'
    ">
    <div class="gacha-container">

      <!-- Loading 遮罩弹窗 -->
      <div v-if="loading" class="loading-mask">
        <div class="loading-box">{{ $t('gacha.loadingTip') }}</div>
      </div>
      <div v-else>
        <el-button class="lucky-gacha-btn active" @click="onGacha" type="warning" plain round >🎴 {{ $t('gacha.luckyGacha') }}</el-button>
        <el-button class="lucky-gacha-btn" @click="onMyGacha" type="warning" plain round>📦 {{ $t('collection.myCollection') }}</el-button>
        <el-button class="lucky-gacha-btn" @click="onCardShop" type="warning" plain round>🏪 {{ $t('gacha.cardShop') }}</el-button>

        <div class="filter-row">
          <div class="coin-group">
            <svg width="36" height="36" viewBox="-2 -2 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g>
                <circle cx="12" cy="12" r="11" fill="#F59E0B" stroke="#D97706" stroke-width="1.5" />
                <circle cx="12" cy="12" r="8" fill="#FCD34D" opacity="0.5" />
                <text x="12" y="16" text-anchor="middle" font-size="9" font-weight="800" fill="#92400E" font-family="Nunito,sans-serif">M</text>

                <animateTransform
                    attributeName="transform"
                    type="translate"
                    values="0 0; 0 -2; 0 0"
                    keyTimes="0; 0.5; 1"
                    dur="0.6s"
                    repeatCount="indefinite" />
              </g>
            </svg>
            <div class="coin-stat">
              <div class="stat-title text-xs text-gray-500 font-medium">{{ $t('studentProgramme.coinBalance') }}</div>
              <div class="stat-num shimmer-gold">{{ Number(userCardsRoleNum).toLocaleString() }}</div>
            </div>
          </div>
        </div>
        <div class="filter-row">
          <div v-for="item in titles" :key="item">
            <el-button style="margin-right: 10px;" plain v-if="studying==1 && item.status==1" size="small" round :class="`tag-${item.id}`" type="warning" @click="goGetCards(item)">{{ item.enName }}</el-button>
            <el-button style="margin-right: 10px;" plain v-if="studying==0 && item.status==1" size="small" round :class="`tag-${item.id}`" type="warning" @click="goGetCards(item)">{{ item.name }}</el-button>
          </div>
<!--          <div class="coin-group">-->
<!--            <img src="@/assets/images/coin.png">-->
<!--            <span class="shimmer-gold">{{ userCardsRoleNum }}</span>-->
<!--          </div>-->
        </div>
        <el-empty v-if="total==0" :image-size="100">
          <div class="card-name" >{{ $t('gacha.saleTime') }}：{{ empty.startTime | formatDateTime}}-{{ empty.endTime | formatDateTime}}</div>
        </el-empty>
        <div class="grid-box limit-eight">
          <div
              class="card-item"
              v-for="(item) in cardList15"
              :class="getCardClass(item)"
              :key="item.id"
          >
            <img class="card-img" :src="item.backImage" alt="" />
          </div>
        </div>
      </div>
      <!-- 悬浮抽卡按钮 固定屏幕正中 -->
      <div class="float-lottery-wrapper">
        <el-button-group>
          <el-badge value="" class="item">
            <button
                class="table-button"
                :disabled="rolling"
                @click="startLottery"
                style="margin-right: 10px;"
            >
              <svg width="20" height="20" viewBox="-2 -2 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                  <circle cx="12" cy="12" r="11" fill="#F59E0B" stroke="#D97706" stroke-width="1.5" />
                  <circle cx="12" cy="12" r="8" fill="#FCD34D" opacity="0.5" />
                  <text x="12" y="16" text-anchor="middle" font-size="9" font-weight="800" fill="#92400E" font-family="Nunito,sans-serif">M</text>
                </g>
              </svg>
              {{ $t('gacha.startGacha') }}
            </button>
          </el-badge>
          <el-badge :value="$t('studentProgramme.discount9')" class="item">
            <button
                class="table-button10"
                :disabled="rolling"
                @click="startLottery10"
            >
              <svg width="20" height="20" viewBox="-2 -2 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                  <circle cx="12" cy="12" r="11" fill="#F59E0B" stroke="#D97706" stroke-width="1.5" />
                  <circle cx="12" cy="12" r="8" fill="#FCD34D" opacity="0.5" />
                  <text x="12" y="16" text-anchor="middle" font-size="9" font-weight="800" fill="#92400E" font-family="Nunito,sans-serif">M</text>

                </g>
              </svg>
              {{ $t('gacha.startGacha10') }}
            </button>

          </el-badge>
        </el-button-group>
        <el-tag
            type="warning"
            style="border-radius: 16px;background: linear-gradient(135deg, rgb(254, 243, 199), rgb(253, 230, 138));
    color: rgb(180, 83, 9);
    border: 1.5px solid rgb(252, 211, 77);
    font-family: Nunito;"
        >★
          {{ $t('studentProgramme.tenPullGuarantee') }}
        </el-tag>
<!--        <el-card>-->
<!--          <p v-for="(line, idx) in $t('studentProgramme.drawDesc')" :key="idx">{{ line }}</p>-->
<!--        </el-card>-->
      </div>
      <!-- 获奖弹窗 - 單抽 无边框透明版 + X关闭 + titleId對應發光邊框 -->
      <div class="modal-mask no-border-modal" v-show="showModal" @click="showModal=false;unlockBodyScroll()">
        <div class="modal-content" @click.stop>
          <!-- 外層容器做發光光暈，動態綁定 glow‑${gotCard.titleId} -->
          <h2 style="color: #1C1A2E">🎉{{ $t('studentProgramme.winning') }}</h2>
          <div class="win-img-wrap" :class="`glow-${gotCard.titleId}`">
            <img :src="gotCard.image" class="win-img no-border-img"/>
          </div>
<!--          <div class="win-text">{{ $t('gacha.congratsGet') }}：{{gotCard.name}}</div>-->
<!--          <div class="card-tag" :class="`tag-${gotCard.propertyId}`">{{ gotCard.propertyName }}</div>-->
<!--          <div class="card-tag" :class="`tag-${gotCard.propertyId}`">{{ studying==0?gotCard.titleName:gotCard.titleEnName }}</div>-->
<!--          <div style="color:#fff;margin-top:10px;">{{ gotCard.content }}</div>-->
          <button
              style="margin-top: 10px;width: 100%;"
              class="table-button"
              @click="showModal=false;unlockBodyScroll()"
          >
            {{ $t('studentProgramme.collectAndClose') }}
          </button>
        </div>
      </div>

      <!-- 十連抽卡結果彈窗，展示全部10張 -->

      <div class="modal-mask no-border-modal" v-show="showTenModal" @click="showTenModal=false;unlockBodyScroll()">
        <div class="modal-content ten-modal-content" @click.stop>
          <h2 style="color: #1C1A2E">🎉{{ $t('studentProgramme.winning') }}</h2>
          <div class="ten-card-grid">
            <div class="ten-card-item" v-for="(card, idx) in drawResultList" :key="idx">
              <div class="win-img-wrap" :class="`glow-${card.titleId}`">
                <img :src="card.image" class="win-img no-border-img"/>
              </div>
<!--              <div class="card-tag" :class="`tag-${card.propertyId}`">-->
<!--                {{ studying==0 ? card.titleName : card.titleEnName }}-->
<!--              </div>-->
<!--              <div class="card-name">{{ card.name }}</div>-->
            </div>
          </div>
          <button
              style="width: 100%;"
              class="table-button"
              @click="showTenModal=false;unlockBodyScroll()"
          >
            {{ $t('studentProgramme.collectAndClose') }}
          </button>
        </div>
      </div>

      <!-- 无机会弹窗 -->
      <div
          class="modal-mask"
          v-show="notRoleShowModal"
          @click="notRoleShowModal = false;unlockBodyScroll()"
      >
        <div v-if="total > 0" class="modal-content" @click.stop>
          <div class="win-title">{{ $t('gacha.tip') }}</div>
          <div class="win-text">{{ $t('gacha.noChanceNow') }}</div>
          <div class="win-sub-title">{{ $t('gacha.howGetChance') }}：</div>
          <div class="win-desc">
            {{ $t('gacha.chanceRule') }}
          </div>
          <el-button class="confirm-btn" size="small" @click="notRoleShowModal = false;unlockBodyScroll()">
            {{ $t('gacha.gotIt') }}
          </el-button>
        </div>
        <div v-if="total==0" class="modal-content" @click.stop>
          <div class="win-title">{{ $t('gacha.tip') }}</div>
          <div class="win-text">{{ $t('gacha.noCardAvailable') }}</div>
          <el-button class="confirm-btn" size="small" @click="notRoleShowModal = false;unlockBodyScroll()">
            {{ $t('gacha.gotIt') }}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCards,getCardTitleList, getUserCardsRoleNum,saveCardsUser } from "@/api/cards";
import {getStudying} from "@/api/user";
import {isPC} from "@/utils/is-rules";
export default {
  data() {
    return {
      isPC: isPC(),
      loading: true,
      userCardsRoleNum: 0,
      activeIndex: -1,
      titleId: null,
      titles: [],
      rolling: false,
      timer: null,
      showModal: false,
      notRoleShowModal: false,
      showTenModal: false,    // 十連彈窗開關
      drawResultList: [],     // 存放十連全部11張抽卡結果
      winName: '',
      winImage: '',
      gotCard:{},
      cardList: [],
      cardList15: [],
      runOrder: [0, 1, 2],
      audioStart: null,
      audioRoll: null,
      audioWin: null,
      backImage: "require('@/assets/images/kaback.png')",
      total: 0,
      studying:0,
      empty: {},
      listQ: {
        _page1: 1,
        _page2: 1,
        _limit: 100,
      },
      cardsUser: {
        userId: null,
        cardId: null,
      },
    };
  },
  mounted() {
    this.audioStart = new Audio(require('@/assets/vedio/roll.mp3'));
  },
  created() {
    this.getStudying();
    this.getUserCardsRoleNum();
    this.indexTitle();
    this.getCards();
  },
  filters: {
    formatDateTime(time) {
      let timeStr = ''
      if(time && typeof time === 'object' && time.date){
        timeStr = time.date
      }else{
        timeStr = time
      }
      if (!timeStr) return "-";
      const d = new Date(timeStr);
      if (isNaN(d.getTime())) return "-";
      const year = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${m}-${day}`;
    }
  },
  computed:{
    getStatusText(){
      return (v)=>{
        return v === 0 ? this.$t('gacha.status.offline') : this.$t('gacha.status.online')
      }
    }
  },
  methods: {
    lockBodyScroll() {
      document.documentElement.classList.add('modal-open');
      document.body.classList.add('modal-open');
    },
    unlockBodyScroll() {
      document.documentElement.classList.remove('modal-open');
      document.body.classList.remove('modal-open');
    },
    async getStudying() {
      const v = await getStudying();
      this.studying = v.data;
    },
    getCardClass(item) {
      const classes = [];
      const propertyId = item.propertyId;
      if (propertyId === 1) classes.push('rarity-1');
      else if (propertyId === 2) classes.push('rarity-2');
      else if (propertyId === 3) classes.push('rarity-3');
      else if (propertyId === 4) classes.push('rarity-4');
      else if (propertyId === 5) classes.push('rarity-5');
      else classes.push('rarity-default');
      if (this.activeIndex === this.cardList.indexOf(item)) {
        classes.push('active');
      }
      return classes;
    },
    goGetCards(row) {
      this.titleId = row.id;
      this.backImage = row.image;
      this.empty = row;
      this.getCards();
    },
    getCards() {
      let form = {
        titleId: this.titleId,
        _page: this.listQ._page2 - 1,
        _limit: this.listQ._limit,
      };
      getCards(form).then((v) => {
        this.cardList = v.data;
        // 截取前15条
        this.cardList15 = this.cardList.slice(0, 15);
        this.total = Number(v.headers["x-total-count"]);
        this.loading = false;
      });
    },
    indexTitle() {
      getCardTitleList().then((v) => {
        this.titles = v.data;
      });
    },
    async getUserCardsRoleNum() {
      const res = await getUserCardsRoleNum();
      this.userCardsRoleNum = res.data;
    },
    onGacha() {
      const newPath = "/gacha";
      const currentPath = this.$route.path;
      if (currentPath !== newPath) {
        this.$router.push({ path: newPath });
      }
    },
    onMyGacha() {
      const newPath = "/myGacha";
      const currentPath = this.$route.path;
      if (currentPath !== newPath) {
        this.$router.push({ path: newPath });
      }
    },
    onCardShop() {
      const newPath = "/cardShop";
      const currentPath = this.$route.path;
      if (currentPath !== newPath) {
        this.$router.push({ path: newPath });
      }
    },
    playSound(type) {
      if (type === 'start') {
        this.audioStart.currentTime = 0;
        this.audioStart.play();
      }
      if (type === 'win') {
        this.audioStart.pause();
        this.audioStart.currentTime = 0;
      }
    },
    getRandomCard2() {
      let random = Math.random() * 100;
      let total = 0;
      for (let i = 0; i < this.cardList.length; i++) {
        total += parseFloat(this.cardList[i].probability);
        if (random < total) {
          return i;
        }
      }
      return 0;
    },
    getRandomCard() {
      const list = this.cardList;
      let totalWeight = 0;
      list.forEach(item => {
        totalWeight += Number(item.probability || 0);
      });
      if (totalWeight <= 0) {
        return Math.floor(Math.random() * list.length);
      }
      const randomVal = Math.random() * totalWeight;
      let accumulate = 0;
      for (let i = 0; i < list.length; i++) {
        const w = Number(list[i].probability);
        accumulate += w;
        if (randomVal < accumulate) {
          return i;
        }
      }
      return Math.floor(Math.random() * list.length);
    },
    //單次抽卡
    async startLottery() {
      if (this.rolling) return;
      this.rolling = true;
      await this.getUserCardsRoleNum();
      if (this.userCardsRoleNum < 3) {
        this.notRoleShowModal = true;
        this.lockBodyScroll();
        return;
      }
      if (this.total == 0) {
        this.notRoleShowModal = true;
        this.lockBodyScroll();
        return;
      }

      this.playSound('start');
      let count = 0;
      const speed = 60;
      const duration = 5000;
      const randomCardIndex = this.getRandomCard();
      const targetCard = this.cardList[randomCardIndex];
      const finalIndex = randomCardIndex;
      this.timer = setInterval(() => {
        this.activeIndex = count % this.cardList.length;
        count++;
        if (count * speed >= duration) {
          clearInterval(this.timer);
          this.activeIndex = finalIndex;
          this.rolling = false;
          this.gotCard = targetCard;
          this.showModal = true;
          this.lockBodyScroll();
          this.playSound('win');
          this.cardsUser.cardId = targetCard.id;
          saveCardsUser([{
            userId: 1,
            cardId: targetCard.id
          }]);
          this.getUserCardsRoleNum();
        }
      }, speed);
    },
    //十連抽卡 9張普通 + 額外1張SSR保底(共10張)，增加滚动动画
    async startLottery10() {
      if (this.rolling) return;
      this.rolling = true;
      let timer = null;
      try {
        await this.getUserCardsRoleNum();
        // 判斷是否有足夠抽卡次數
        if (this.userCardsRoleNum < 27) {
          this.notRoleShowModal = true;
          this.lockBodyScroll();
          return;
        }
        if (this.total == 0) {
          this.notRoleShowModal = true;
          this.lockBodyScroll();
          return;
        }

        this.playSound('start');
        let count = 0;
        const speed = 60;
        const duration = 5000;
        // 【动画阶段】卡片滚动高亮，和单抽逻辑保持一致
        timer = setInterval(() => {
          this.activeIndex = count % this.cardList.length;
          count++;
          if (count * speed >= duration) {
            clearInterval(timer);
            timer = null; // 置空，標記已清除
            // 動畫結束
            (async () => {
              try {
                const drawResultList = [];
                // ===== 抽取10張普通卡 =====
                for(let i = 0; i < 9; i++){
                  const randomIndex = this.getRandomCard();
                  const cardItem = this.cardList[randomIndex];
                  drawResultList.push(cardItem);
                }
                // ===== 額外贈送：強制抽一張SSR(propertyId=4)或更高稀有卡 =====
                const ssrPool = this.cardList.filter(card => card.propertyId >= 4);
                let bonusCard;
                if(ssrPool.length > 0){
                  const randomSsrIdx = Math.floor(Math.random() * ssrPool.length);
                  bonusCard = ssrPool[randomSsrIdx];
                }else{
                  // 兜底：卡池無SSR時隨機取一張
                  const randomIndex = this.getRandomCard();
                  bonusCard = this.cardList[randomIndex];
                }
                drawResultList.push(bonusCard);

                // 一次性批量傳入10個卡片物件
                const batchParams = drawResultList.map(item => {
                  return {
                    userId: this.cardsUser.userId,
                    cardId: item.id
                  };
                });
                console.log('準備調用saveCardsUser，參數：', batchParams);
                await saveCardsUser(batchParams);
                console.log('saveCardsUser調用成功');

                this.drawResultList = drawResultList;
                await this.getUserCardsRoleNum();
                this.showTenModal = true;
                this.lockBodyScroll();
                this.playSound('win');
              } catch (err) {
                console.error('十連抽 內部異常:', err);
              } finally {
                this.rolling = false;
              }
            })();
          }
        }, speed);
      } catch (err) {
        console.error('十連抽外層異常：', err);
        // 發生外層錯誤時，才清除定時器
        if(timer){
          clearInterval(timer);
          timer = null;
        }
        this.rolling = false;
      }
      // ===== 重點：刪除原本的 finally！！=====
    },
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
    this.unlockBodyScroll();
  },
};
</script>

<style scoped>
/* Loading 遮罩弹窗 */
.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1002;
}
.loading-box {
  background: #fff;
  padding: 25px 40px;
  border-radius: 12px;
  font-size: 16px;
  color: #333;
}
.gacha-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 2.5rem;
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
}
.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
  position: relative;
  z-index: 1001 !important;
}
.left-empty {
  flex: 1;
  text-align: left;
}
.right-empty {
  flex: 1;
  text-align: right;
}
.title {
  flex: 2;
  text-align: center;
  color: #fff;
  text-shadow: 0 0 10px rgba(255, 215, 0, 0.7);
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 3rem;
  font-weight: 700;
  font-family: "GenSenRoundedTW", "Helvetica", "Arial";
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.8);
}
.grid-box {
  display: grid;
  grid-template-columns: repeat(5, 197px);
  grid-auto-rows: 274px;
  gap: 12px;
  justify-content: center;
}
/* ========== 卡片样式：无边框 + 黑色发光底 ========== */
.card-item {
  position: relative;
  background: #000;
  border: none;
  border-radius: 5px;
  padding: 0;
  overflow: hidden;
  transition: all 0.1s ease;
  box-shadow: 0 0 20px rgba(255,255,255,0.15);
}
.card-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
}
.card-name, .card-rate {
  position: relative;
  z-index: 2;
  color: #fff;
  text-shadow: 0 0 3px #000;
}
.card-name {
  font-size: 16px;
  font-weight: bold;
  margin-top: 15px;
}
.card-rate {
  font-size: 12px;
  color: #eee;
  margin-top: 4px;
}
.card-item.active {
  transform: scale(1.05);
  box-shadow: 0 0 40px 10px currentColor !important;
  border-color: #fff !important;
}
.rarity-1 {
  color: #fff;
}
.rarity-2 {
  color: #fff;
}
.rarity-3 {
  color: #fff;
}
.rarity-4 {
  color: #fff;
}
.rarity-5 {
  color: #fff;
}
.rarity-default {
  color: #fff;
}
.table-button {
  border: none;
  border-radius: 1.75rem;
  font-size: 1.2rem;
  line-height: 1.5rem;
  padding: 0.5rem 2rem;
  background: linear-gradient(135deg, rgb(245, 158, 11), rgb(217, 119, 6));
  color: white;
  font-family: Nunito;
  box-shadow: rgba(245, 158, 11, 0.4) 0px 4px 16px;
}
.table-button10 {
  border: none;
  border-radius: 1.75rem;
  font-size: 1.2rem;
  line-height: 1.5rem;
  padding: 0.5rem 2rem;
  background: linear-gradient(135deg, rgb(124, 58, 237), rgb(91, 33, 182));
  color: white;
  font-family: Nunito;
  box-shadow: rgba(124, 58, 237, 0.4) 0px 4px 16px;
}
.table-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
/* ---------- 悬浮抽卡按钮 ---------- */
.float-lottery-wrapper {
  position: fixed;
  left: 50%;
  bottom: 10vh;
  transform: translateX(-50%);
  z-index: 1001;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.chance-text {
  font-size: 14px;
  color: #fff;
  text-shadow: 0 1px 3px #000;
}
/* ---------- 无边框透明弹窗 ---------- */
.no-border-modal .modal-content {
  background: #ffffff !important;
  box-shadow: none !important;
  padding-left: 50px !important;
  padding-right: 50px !important;
  border: none !important;
  border-radius: 25px !important;
}
.no-border-img {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent !important;
}
/* 关闭X */
.close-x {
  position: absolute;
  right: -10px;
  top: -10px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(0,0,0,0.5);
  color: #fff;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
}
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;
}
.modal-content {
  text-align: center;
  background: #fff;
  padding: 20px;
  position: relative;
  width: 320px;
  max-width: 360px;
  border-radius: 24px;
}
.win-img {
  display: block;
  width: 100%;
  border-radius: 18px;
}
/* titleId對應外發光 shadow，和tag顏色對應 */
.glow-1 { box-shadow: 0 0 22px 6px #7dd3fc; }
.glow-2 { box-shadow: 0 0 22px 6px #a78bfa; }
.glow-3 { box-shadow: 0 0 22px 6px #facc15; }
.glow-4 { box-shadow: 0 0 22px 6px #fb923c; }
.glow-5 { box-shadow: 0 0 22px 6px #f472b6; }
.glow-6 { box-shadow: 0 0 22px 6px #34d399; }
.glow-7 { box-shadow: 0 0 22px 6px #f87171; }
.glow-8 { box-shadow: 0 0 22px 6px #22d3ee; }
.glow-9 { box-shadow: 0 0 22px 6px #c084fc; }
.glow-10 { box-shadow: 0 0 22px 6px #4ade80; }
.win-text {
  font-size: 20px;
  font-weight: bold;
  margin: 15px 0;
  color: #ff6600;
}
.win-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 16px;
}
.win-sub-title {
  font-size: 15px;
  font-weight: 500;
  color: #333;
  text-align: left;
}
.win-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.7;
  text-align: left;
  margin-bottom: 24px;
}
.confirm-btn {
  background: #ff7d00 !important;
  border-color: #ff7d00 !important;
  color: #fff !important;
  border-radius: 20px;
}
.card-tag {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
  margin: 2px;
}
/*1:淺天藍 2:香芋紫 3:金黃 4:活力橙 5:蜜桃粉*/
/*6:薄荷綠 7:草莓紅 8:青湖藍 9:夢幻紫 10:嫩草綠*/
.tag-1 { background: #ffffff;color: #4ade80;border: 2px solid rgba(74, 222, 128, 0.33); }
.tag-2 { background: #ffffff;color: #a78bfa;border: 2px solid rgba(167, 139, 250, 0.33); }
.tag-3 { background: #ffffff;color: #facc15;border: 2px solid rgba(250, 204, 21, 0.33); }
.tag-4 { background: #ffffff;color: #fb923c;border: 2px solid rgba(251, 146, 60, 0.33); }
.tag-5 { background: #ffffff;color: #f472b6;border: 2px solid rgba(244, 114, 182, 0.33); }
.tag-6 { background: #ffffff;color: #34d399;border: 2px solid rgba(52, 211, 153, 0.33); }
.tag-7 { background: #ffffff;color: #f87171;border: 2px solid rgba(248, 113, 113, 0.33); }
.tag-8 { background: #ffffff;color: #22d3ee;border: 2px solid rgba(34, 211, 238, 0.33); }
.tag-9 { background: #ffffff;color: #c084fc;border: 2px solid rgba(192, 132, 252, 0.33); }
.tag-10 { background: #ffffff;color: #7dd3fc;border: 2px solid rgba(125, 211, 252, 0.33); }

/* ====== 十連彈窗新增樣式 ====== */
.ten-modal-content {
  width: 784px;
  max-width: 1200px;
  max-height: 115vh;
}
.ten-card-grid {
  display: grid;
  grid-template-columns: repeat(5, 130px);
  gap: 14px;
  justify-content: center;
  margin: 50px;
}
.ten-card-item {
  text-align: center;
}
.ten-card-item .win-img {
  width: 100%;
}
.ten-card-item .card-name {
  font-size: 13px;
  color: #fff;
  margin:4px 0;
}

/* ios safari 弹窗滚动穿透修复 */
:global(html.modal-open), :global(body.modal-open) {
  overflow: hidden !important;
  height: 100% !important;
  position: fixed !important;
  width: 100%;
}
.filter-row {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 12px 16px;
  /* 深色半透明，适配深色背景 */
  background: rgba(251, 251, 252, 1);
  border-radius: 16px;
  flex-wrap: wrap; /* 核心：手机自动换行 */
  width: 100%;
  box-sizing: border-box;
  margin-top: 10px;border: 1px solid rgb(253, 230, 138);
}
.filter-group {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.coin-group {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0; /* 金币区域不会被压缩 */
}
.coin-group img {
  height: 32px;
  width: auto;
  display: block;
  animation: coinFloat 2s ease-in-out infinite;
  transform-origin: center center;
}
.shimmer-gold {
  -webkit-text-fill-color: transparent;
  background: linear-gradient(90deg, #d97706, #fcd34d, #f59e0b, #fcd34d, #d97706) 0 0 / 200%;
  -webkit-background-clip: text;
  background-clip: text;
  animation: 2.5s linear infinite shimmer;
}

@keyframes coinFloat {
  0% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-4px) rotate(8deg);
  }
  100% {
    transform: translateY(0) rotate(0deg);
  }
}
@keyframes shimmer {
  0% { background-position: 0%; }
  100% { background-position: 200%; }
}

/* ========= 响应式媒体查询（手机、平板） ========= */
/* 平板：小于1100px，卡片改成2列 */
@media (max-width: 1100px) {
  .card-grid {
    grid-template-columns: repeat(2, minmax(260px, 1fr));
    grid-auto-rows: 365px;
  }
  .title {
    font-size: 2.2rem;
  }
}

/* 手机：小于768px，卡片1列，缩小尺寸 */
@media (max-width: 768px) {
  .card-grid {
    grid-template-columns: repeat(2, 158px);
    grid-auto-rows: 227px;
  }
  .card-item {
    min-height: 274px;
  }
  .title {
    font-size: 1.6rem;
  }
  .modal-close-x {
    right: 4px;
    top: 4px;
  }
}
/* 中奖图片：循环发光斜条纹 */
.win-img-wrap {
  position: relative;
  display: inline-block;
  overflow: hidden;
  border-radius: 18px;
}
.win-img-wrap::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 16%;
  height: 100%;
  background: linear-gradient(
      120deg,
      transparent 0%,
      rgba(255, 255, 255, 0.75) 50%,
      transparent 100%
  );
  transform: skewX(-20deg);
  animation: winStripeMove 1.8s linear infinite;
  pointer-events: none;
  z-index: 5;
}

@keyframes winStripeMove {
  0% {
    left: -50%;
  }
  100% {
    left: 120%;
  }
}
.card-name {
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  margin-bottom: 8px;
  text-shadow: 0 2px 8px #444;
  /* 单行文字省略 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* 卡通全屏背景 */
.page-wrap {
  min-height: 100vh;
  background-image: url("~@/assets/images/cartoon_living.png");
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  position: relative;
}
/* 暗色半透明蒙版，防止背景太亮看不清内容 */
.page-wrap::before {
  content: '';
  position: fixed;
  inset: 0;
  background: rgba(255, 248, 237,0.45);
  z-index: 0;
}
.gacha-container {
  position: relative;
  z-index: 1;
}
.lucky-gacha-btn {
  background: white;
  color: rgb(120, 98, 26);
  font-family: Nunito;
  border: 2px solid rgb(253, 230, 138);
}

.lucky-gacha-btn.active {
  background: rgb(28, 26, 46);
  color: white;
  font-family: Nunito;
  border: 2px solid rgb(28, 26, 46);
}
.coin-stat {
  text-align: left;
}
.stat-title {
  font-size:14px;
  color:#666;
}
.stat-num {
  font-size:24px;
  color:#facc15;
  font-family: Nunito;
  font-weight: 900;
}
.shimmer-gold {
  background: linear-gradient(90deg, #D97706, #FCD34D, #F59E0B, #FCD34D, #D97706);
  background-size: 200% auto;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: shimmer 2.5s linear infinite;
}
text-gray-500 {
  color: #6a7282;
}
.font-medium {
  --tw-font-weight: 500;
  font-weight: 500;
}
.text-xs {
  font-size: 12px;
  line-height: 12.33px;
}
.table-button10:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
}

</style>
